module.exports = __webpack_public_path__ + "img/ca.f3277db4.svg";